import * as React from "react";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import useEscapeKey from "../models/useEscapeKey";
import { RefObject } from "react";
import useEnterKeyAsOk from "../models/useEnterKeyAsOk";
import { getLeftTopFromStyle, setLeftTopInStyle } from "../modelViews/GraficElementUtils";
import { itx } from "../translationItx/itx";

var mouseIsDown = false;
var pStart = { x: 0, y: 0 };

export function FieldSet(props: { label?: string; children: any; widthTable?: string; style?: any }) {
  const widt = props.widthTable ? props.widthTable : "100%";
  return (
    <table style={{ width: widt, ...props.style }} className="fieldGroup">
      <colgroup>
        <col style={{ width: "100px" }} />
        <col style={{ maxWidth: "100%" }} />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody> {props.children}</tbody>
    </table>
  );
}
export function Field(props: { label?: string; children: any }) {
  return (
    <tr>
      <td>{props.label}</td>

      <td>{props.children}</td>
    </tr>
  );
}

export default function OnboardingBaseWindow(props: {
  className?: string;
  onOk?: (save: boolean) => boolean;
  title?: string;
  titleSuffix?: any;
  noOkButton?: boolean;
  children: any;
  moreButtons?: any;
  headerRef?: RefObject<HTMLDivElement> | null;
  enterAsOk?: boolean;
}) {
  var { className, onOk, title, titleSuffix, noOkButton, moreButtons, headerRef, enterAsOk } = props;

  function onMouseMove(event: any) {
    const elm = document.getElementById("nonModalOnBoardingWrapper");
    if (elm) {
      if (!mouseIsDown) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      const p = {
        x: event.clientX || event.touches[0]?.clientX,
        y: event.clientY || event.touches[0]?.clientY,
      };

      const pCurrent = getLeftTopFromStyle(elm);

      const delta = { x: p.x - pStart.x, y: p.y - pStart.y };

      pCurrent.x += delta.x;
      pCurrent.y += delta.y;

      setLeftTopInStyle(elm, pCurrent);
      pStart = p;
    }
  }

  function onMouseDown(event: any) {
    const elm = document.getElementById("nonModalOnBoardingWrapper");
    if (elm) {
      mouseIsDown = true;
      // elm.setPointerCapture(event.pointerId);
      pStart = {
        x: event.clientX || event.touches[0]?.clientX,
        y: event.clientY || event.touches[0]?.clientY,
      };
    }
  }
  function onMouseUp(event: any) {
    const elm = document.getElementById("nonModalOnBoardingWrapper");
    if (elm) {
      // elm.releasePointerCapture(event.pointerId);
      mouseIsDown = false;
    }
  }

  function onOkClick(saveInLocalStorage?: boolean) {
    if (props.onOk) {
      if (props.onOk(saveInLocalStorage ? true : false)) {
        handleClose();
      }
    } else {
      handleClose();
    }
  }

  function handleClose() {
    state.onBoadingManager.closeWindow();
  }

  state.dialogManager.onClose = () => {
    return true;
  };

  useOnChangeWatcher(state.dialogManager);
  useEscapeKey(handleClose);
  useEnterKeyAsOk(enterAsOk == false ? undefined : onOkClick);

  if (noOkButton == undefined) {
    noOkButton = false;
  }

  const buttons = (
    <div className="dialogButtons">
      <div className="dialogFooterLeftText"></div>

      <button
        className="button"
        onClick={() => {
          onOkClick(true);
        }}
      >
        {itx("", "nicht mehr anzeigen")}
      </button>
      {!noOkButton && (
        <button className="button" onClick={() => onOkClick()} autoFocus>
          {state.translate("okUnderStood", "ok, verstanden")}
        </button>
      )}

      <div className="dialogFooterRightText"></div>
    </div>
  );
  className = (className || "") + " dialog";

  // zIndex: "1" avoids "click throuh"

  const isModal = false;

  return (
    <div className={className} style={{ zIndex: "20" }} key={title}>
      <div
        ref={headerRef}
        className="windowHeader"
        onMouseDown={!isModal ? onMouseDown : undefined}
        onMouseMove={!isModal ? onMouseMove : undefined}
        onMouseUp={!isModal ? onMouseUp : undefined}
        style={{ cursor: !isModal ? "move" : undefined }}
      >
        <div className="dialogHeaderTitle" style={{ marginLeft: "auto" }}>
          {title}&nbsp;&nbsp;{titleSuffix}
        </div>
        <div style={{ marginLeft: "auto" }}></div>
      </div>
      <div
        className="dialogBody"
        style={{
          width: "100%",
          padding: "20px",
          overflow: "auto",
          textAlign: "left",
        }}
      >
        {props.children}
      </div>
      {buttons}
    </div>
  );
}
